<div class="sg-header">
    <div class="container-fluid">
        <div class="row">
            <div class="d-flex sg-header__segment sg-header__segment--heading align-items-center">
                <a [routerLink]="homeUrl" class="d-flex px-3">
                    <img [src]="logoUrl" [alt]="logoAlt" />
                </a>
            </div>

            <div class="d-flex px-0">
                <div class="triangle-top-left"></div>
            </div>

            <div class="d-flex flex-grow-1 sg-header__segment sg-header__segment--body align-items-center pr-xl-3">
                <div *ngIf="cities | async" ngbDropdown class="d-none d-sm-flex mx-3">
                    <a class="text-button-default -medium" href="" (click)="$event.preventDefault();$event.stopPropagation();" ngbDropdownToggle>{{ (cities | async)?.currentCity }}</a>

                    <div class="dropdown-menu" ngbDropdownMenu>
                      <a class="dropdown-item sg-link" *ngFor="let city of (cities | async)?.cities" [routerLink]="['/', city.slug]">{{ city.name }}</a>
                    </div>
                </div>

                <div *ngIf="!hideSearch" class="d-none d-lg-flex align-items-center justy-content-start ml-3">
                    <a class="text-button-default -medium" href="" (click)="searchToggle($event);$event.preventDefault();$event.stopPropagation();">
                        <mlp-ng-icon name="search" class="mr-1"></mlp-ng-icon> search
                    </a>
                </div>

                <div class="d-flex d-lg-none align-items-center justify-content-end h-100 w-100">
                    <a *ngIf="!hideSearch" href="" (click)="searchToggle($event);">
                        <mlp-ng-icon name="search" size="medium" weight="normal" class="mr-4" [class.sg-color__white]="search"></mlp-ng-icon>
                    </a>

                    <a *ngIf="phoneNumber" href="tel:{{phoneNumber}}">
                        <mlp-ng-icon name="phone" size="medium" weight="normal" class="mr-2"></mlp-ng-icon>
                    </a>

                    <a href="" (click)="mobileNavToggle(); false">
                        <mlp-ng-icon name="custom-navigation-menu" [class.sg-color__white]="mobileNav" size="medium" weight="normal" class="ml-3 mr-3"></mlp-ng-icon>
                    </a>
                </div>

                <div class="d-none d-lg-flex align-items-center justify-content-end h-100 w-100 pr-lg-3 pr-xl-0">
                    <mlp-ng-text-button-external *ngIf="phoneNumber" url="tel:{{phoneNumber}}" [label]="phoneNumber" weight="medium" iconName="phone-circle" class="mr-4"></mlp-ng-text-button-external>

                    <div *ngIf="!loggedIn" class="d-flex flex-row">
                        <a class="text-button-default -medium" href="" (click)="signUpClick();$event.preventDefault();$event.stopPropagation();">
                            <mlp-ng-icon name="single-neutral-circle" class="mr-1"></mlp-ng-icon> Sign up
                        </a>
                        <div class="mx-3">|</div>
                        <a class="text-button-default -medium" href="" (click)="loginClick();$event.preventDefault();$event.stopPropagation();">
                            Login
                        </a>
                    </div>

                    <div *ngIf="loggedIn" class="d-flex flex-row" ngbDropdown>
                        <a class="text-button-default -medium" href="" (click)="$event.preventDefault();$event.stopPropagation();" ngbDropdownToggle>
                            <mlp-ng-icon name="single-neutral-circle" class="mr-1"></mlp-ng-icon> My Account
                        </a>

                        <div class="dropdown-menu" ngbDropdownMenu>
                            <a class="dropdown-item sg-link" *ngFor="let link of links" [routerLink]="['/user/', link.link]">{{ link.label }}</a>
                            <a class="dropdown-item sg-link" href="" (click)="logoutClick()">Log Out</a>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="trailing" class="d-none d-xl-flex px-0">
                <div class="triangle-top-right"></div>
            </div>

            <div *ngIf="trailing" class="d-none d-xl-flex align-items-center sg-header__segment sg-header__segment--trailing px-3">
              <mlp-ng-text-button-internal [queryParamsHandling]="''" *ngIf="trailing.label && !trailing.href" [label]="trailing.label" [url]="trailing.routerLink" weight="medium"></mlp-ng-text-button-internal>
              <mlp-ng-text-button-external *ngIf="trailing.label && trailing.href" [label]="trailing.label" [url]="trailing.href" weight="medium"></mlp-ng-text-button-external>

              <a *ngIf="trailing.imgUrl" [routerLink]="trailing.routerLink" class="d-flex">
                <img [src]="trailing.imgUrl" [alt]="trailing.imgAlt" />
              </a>
            </div>
        </div>
    </div>

    <div class="sg-header__fader"
        *ngIf="search || mobileNav"
        [@fadeInFadeOutAnimation]
        [style.height.px]="faderHeight"
        (click)="closeSearchMobileNav()"
    ></div>

    <div class="sg-header__dropdown mobileNav" [@ngForAnimationFold]="mobileNav ? 'opened' : 'closed'">
        <div class="px-3 my-3 col-12">
            <mlp-ng-text-button-internal [queryParamsHandling]="''" [url]="homeUrl" iconName="house-2" label="Home"></mlp-ng-text-button-internal>
        </div>

        <div *ngIf="!hideSearch && cities | async" class="px-3 mb-3 col-12">
            <mlp-ng-text-button-internal [queryParamsHandling]="''" (click)="searchToggle($event)" label="Search" iconName="search"></mlp-ng-text-button-internal>
        </div>

        <div *ngIf="citySelectOptions && loggedIn" class="d-block d-sm-none px-3 my-3 col-12">
            <p class="mb-1 font size14 sg-header__location">Search Location</p>
            <form [formGroup]="form">
                <mlp-ng-select formControlName="city" [options]="citySelectOptions"></mlp-ng-select>
            </form>
        </div>

        <div *ngIf="!loggedIn">
            <div class="px-3 mb-3 col-12">
                <mlp-ng-text-button-internal [queryParamsHandling]="''" (click)="loginClick()" iconName="login-1" label="Login"></mlp-ng-text-button-internal>
            </div>

            <div class="px-3 my-3 col-12">
                <mlp-ng-text-button-internal [queryParamsHandling]="''" (click)="signUpClick()" iconName="single-neutral-actions-add" label="Sign up"></mlp-ng-text-button-internal>
            </div>
        </div>

        <div *ngIf="loggedIn" class="px-3 my-3 col-12">
            <ng-content select="[mobile]"></ng-content>
        </div>

        <div *ngIf="phoneNumber" class="px-3 my-3 col-12">
            <mlp-ng-text-button-external url="tel:{{phoneNumber}}" [label]="phoneNumber" weight="normal" iconName="phone-circle" class="mr-4"></mlp-ng-text-button-external>
        </div>

        <div *ngIf="trailing" class="px-3 my-3 col-12">
            <mlp-ng-text-button-internal [queryParamsHandling]="''" [url]="trailing.routerLink" label="Become a venue partner" weight="normal" iconName="check-circle-1" class="mr-4"></mlp-ng-text-button-internal>
        </div>

        <div *ngIf="citySelectOptions && !loggedIn" class="d-block d-sm-none px-3 my-3 col-12">
            <p class="mb-1 font size14 sg-header__dropdown__location">Search Location</p>
            <form [formGroup]="form">
                <mlp-ng-select formControlName="city" [options]="citySelectOptions"></mlp-ng-select>
            </form>
        </div>
    </div>

    <div class="sg-header__dropdown search" [@ngForAnimationFold]="search ? 'opened' : 'closed'">
        <ng-content select="[search]"></ng-content>
    </div>
</div>
